module.exports = __webpack_public_path__ + "img/test-r-img.7d29e6ad.jpg";